import { computed } from "@vue/composition-api";
import { PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import usePaymentPackages from "@/hooks/usePaymentPackages";
import { PaymentPackageMap } from "@/views/PageScheduledMassMessage/type";

export default function usePrice() {
  const { paymentPackages, getPaymentPackages } = usePaymentPackages([PaymentPackageEnum.MESSAGE_ATTACHMENT]);
  getPaymentPackages();

  const paymentPackageMap = computed<PaymentPackageMap>(() =>
    paymentPackages.value.reduce<PaymentPackageMap>((acc, price) => {
      acc[price.id] = price.amount;
      return acc;
    }, {})
  );

  return {
    paymentPackageMap,
  };
}
